export enum ConversationRatingQuestionCodeEnum {
  HelpfulThumbs = 'HELPFUL_THUMBS',
  ExperienceThumbs = 'EXPERIENCE_THUMBS',
  HelpfulWhy = 'HELPFUL_WHY',
  Feedback = 'FEEDBACK',
}

export enum ConversationRatingResponseCodeEnum {
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
  Other = 'OTHER',
  Unset = 'UNSET',
}
